import { Injectable } from '@angular/core'
import {
  HttpService,
  IExportFileResponse,
  INew_TableAction,
  New_TableOperator,
  TableActionsService
} from '@lla-platform/core/core-data-access'
import { Observable } from 'rxjs'
import {
  IEmployeeDetail,
  IEmployeeListResponse,
  IEmployeeUpdateRequest
} from '../interfaces/employee-list.interface'
import { EMPLOYEE_API_URL } from './employee-api-routes'
import { cloneDeep } from 'lodash'

@Injectable({
  providedIn: 'root'
})
export class EmployeeService {
  constructor(
    private http: HttpService,
    private tableActionsService: TableActionsService
  ) {}

  getEmployee(id: string): Observable<IEmployeeDetail> {
    return this.http.get(EMPLOYEE_API_URL.getEmployee(id))
  }

  updateEmployee(payload: Partial<IEmployeeUpdateRequest>) {
    return this.http.post(EMPLOYEE_API_URL.updateEmployee, payload)
  }

  getEmployeeList(info: INew_TableAction): Observable<IEmployeeListResponse> {
    return this.http.post(
      EMPLOYEE_API_URL.employeeList,
      this.tableActionsService.createRequestPayload(this.prepareEmployeeListRequest(info))
    )
  }

  exportEmployeeList(info: INew_TableAction): Observable<IExportFileResponse> {
    return this.http.post(
      EMPLOYEE_API_URL.exportEmployeeList,
      this.tableActionsService.createRequestPayload(this.prepareEmployeeListRequest(info))
    )
  }

  private prepareEmployeeListRequest(info: INew_TableAction) {
    const newInfo = cloneDeep(info)
    if (newInfo.filters?.['isActive']) {
      const items = newInfo.filters['isActive'].items
      newInfo.filters['isArchived'] = {
        ...newInfo.filters['isActive'],
        key: 'isArchived',
        items:
          items && items.length > 0
            ? [
                {
                  operator: New_TableOperator.Equals,
                  value: !items[0]?.value
                }
              ]
            : undefined
      }
      delete newInfo.filters['isActive']
    }
    return newInfo
  }
}
